
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EducationalContentStatus"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"isSuperUser"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"priorityListData"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PriorityListData"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"educationalContentStatus"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"isSuperUser"},"value":{"kind":"Variable","name":{"kind":"Name","value":"isSuperUser"}}},{"kind":"Argument","name":{"kind":"Name","value":"priorityListData"},"value":{"kind":"Variable","name":{"kind":"Name","value":"priorityListData"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasViewedContent"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasViewedMemberSelectorAlert"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showCompareModal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showCompareModalNative"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showCompareCoachmark"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"showCompareCoachmarkWeb"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastUpdatedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"distanceFilterBtnClickedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"upcomingAvailabilityFilterBtnClickedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"prioritySchedulingFilterBtnClickedDate"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hideDsnpPlanCoachmark"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasViewedGuestStartModal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasViewedGuestLobBanner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasViewedGuestCoverageTypeBanner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasViewedGuestPlanBanner"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasViewedGuestReadyToEnrolCoach"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"hasViewedSignInCoach"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"isGuest"},"arguments":[],"directives":[]}]}}]}}],"loc":{"start":0,"end":791}};
    doc.loc.source = {"body":"query EducationalContentStatus(\n  $userId: String\n  $isSuperUser: Boolean\n  $priorityListData: [PriorityListData]\n) {\n  educationalContentStatus(\n    userId: $userId\n    isSuperUser: $isSuperUser\n    priorityListData: $priorityListData\n  ) {\n    uuid\n    hasViewedContent\n    hasViewedMemberSelectorAlert\n    showCompareModal\n    showCompareModalNative\n    showCompareCoachmark\n    showCompareCoachmarkWeb\n    createdDate\n    lastUpdatedDate\n    distanceFilterBtnClickedDate\n    upcomingAvailabilityFilterBtnClickedDate\n    prioritySchedulingFilterBtnClickedDate\n    hideDsnpPlanCoachmark\n    hasViewedGuestStartModal\n    hasViewedGuestLobBanner\n    hasViewedGuestCoverageTypeBanner\n    hasViewedGuestPlanBanner\n    hasViewedGuestReadyToEnrolCoach\n    hasViewedSignInCoach\n    isGuest\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["EducationalContentStatus"] = oneQuery(doc, "EducationalContentStatus");
        
